import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {TmcWarning} from "./component/TmcWarningDialogComponent";
import {TmcWarningAction} from "./models/TmcWarningAction";

export class TmcWarningDialog {

    public static id = "tmcWarningDialog";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {

    }

    public async open(): Promise<TmcWarningAction> {
        const settings: IModalSettings = {
            backdrop: "static",
            size: "md",
            component: TmcWarning
        };
        const instance = this.$uibModal.open(settings);
        return instance.result;
    }
}
